import { Injectable } from '@angular/core';
import { logError } from '@office-start/telemetry-service';

import { InstrumentationService, KnownInstrumentationEvents } from '../instrumentation/instrumentation.service';
import { ClientStartupConfigService } from '../shared-context/client-startup-config.service';
import { BrowserStorageService } from './browser-storage.service';
import { StorageType, WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService extends BrowserStorageService {

    constructor(
        instrumentationService: InstrumentationService,
        startupConfigService: ClientStartupConfigService,
        windowService: WindowService
    ) {
        // Some versions of IE throw errors when accessing storage
        try {
            super(startupConfigService.config.puid, windowService.getStorage(StorageType.LocalStorage));
            if (!windowService.isStorageAvailable(StorageType.LocalStorage)) {
                instrumentationService.logGenericEvent(KnownInstrumentationEvents.LocalStorageUnavailable);
                logError({ eventName: 'Local_Storage_Unavailable'});
            }
        } catch (error) {
            // Do nothing
        }
    }
}
